import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styled from "styled-components";

/**
 * The confirmation a /shop grid card shows after Add to cart: which vendor's
 * cart the item went into (each vendor keeps its own cart and checkout), how
 * many went in when a minimum order put in more than one, and the way to the
 * cart. Rendered inside a toast, which sits inside the router.
 */
const Title = styled.div`
  font-weight: 800;
  font-size: 14px;
  color: #1f2a2e;
`;
const Detail = styled.div`
  font-size: 12.5px;
  color: #4a5b61;
  margin-top: 2px;
  overflow-wrap: anywhere;
`;
const CartLink = styled(Link)`
  display: inline-block;
  margin-top: 6px;
  font-size: 13px;
  font-weight: 800;
  color: #03660c;
  text-decoration: underline;
  text-underline-offset: 2px;
  &:hover {
    color: #024f09;
  }
`;

export default function AddedToCartNotice({ name, vendorName, quantity }) {
  const many = Number(quantity) > 1;
  return (
    <div>
      <Title>Added to your {vendorName || "vendor's"} cart</Title>
      <Detail>
        {many ? `${quantity} x ${name}, the least this item is sold in` : name}
      </Detail>
      <CartLink to="/cart">View cart</CartLink>
    </div>
  );
}

AddedToCartNotice.propTypes = {
  name: PropTypes.string,
  vendorName: PropTypes.string,
  quantity: PropTypes.number,
};
